import React from 'react';
import Helmet from 'react-helmet';
import { Box } from 'src/kit/Box';
import { EmployerNav, EmployerFooter } from './organisms';

type Props = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  image?: string;
  noIndex?: boolean;
};

const EmployerLayout = ({ children, title, description, image, noIndex }: Props) => {
  const fullTitle = title ? `${title}` : 'Sainoo - Calmon Partners';
  const defaultDescription =
    'The premium recruitment ecosystem for PE funds, investment banks and M&A boutiques. Post jobs, assess candidates, and build your team.';
  const metaDescription = description || defaultDescription;

  const schemaData = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Sainoo',
    url: 'https://sainoo.com',
    logo: 'https://sainoo.com/logo.png',
    description: 'The premium recruitment ecosystem for Corporate Finance, PE and Investment Banking.',
    sameAs: ['https://www.linkedin.com/company/sainoo', 'https://www.facebook.com/sainoofficial']
  });

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        {metaDescription && <meta name="description" content={metaDescription} />}
        {noIndex && <meta name="robots" content="noindex,follow" />}

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="dns-prefetch" href="https://www.linkedin.com" />

        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={metaDescription} />
        {image && <meta property="og:image" content={image} />}
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={metaDescription} />
        {image && <meta name="twitter:image" content={image} />}

        <script type="application/ld+json">{schemaData}</script>
      </Helmet>

      <Box as="main" id="main-content" style={{ background: '#ffffff', minHeight: '100vh' }}>
        <EmployerNav />
        {children}
        <EmployerFooter />
      </Box>
    </>
  );
};

export default EmployerLayout;